import Vue from 'vue';

import globalConfig from '@utiles/officialStore/globalConfig';

// 同步index里面的：
export const UPDATE_IS_INSTALL = 'UPDATE_IS_INSTALL'; // 更新是否安装pwa


export const UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP = 'UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP'; // 更新是否显示pwa跳转领奖弹窗



const gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';

  const getVisibleGotoAwardTipsPopup = () => {
    let _visibleGotoAwardTipsPopup = false;
    try {
      let _isInstallClick = sessionStorage?.getItem?.(`${gameId}_pwa_install_click`);
      _visibleGotoAwardTipsPopup = _isInstallClick == 1 || false;
      if(_isInstallClick){
        sessionStorage?.removeItem?.(`${gameId}_pwa_install_click`);
      }
    } catch (error) {
      console.error(error)
    }
    return _visibleGotoAwardTipsPopup
  }



export default {
  state: {
    isInstall: (() => {
      try {
         // 如果 window.isInstall 不存在，先创建它
         if (!window.isInstall) {
          window.isInstall = { value: true };
        }
        // 如果已经是响应式对象（通过 __ob__ 属性判断），直接返回
        if (window.isInstall.__ob__) {
           
          return window.isInstall;
        }
        // 创建响应式对象并同步到 window.isInstall
        const pwaState = Vue.observable(window.isInstall);
        window.isInstall = pwaState;
        // 由于本地开发的是否安装事件不会触发，所以模拟一下设置为false（未安装）
        if (process.env.NODE_ENV === 'development') {
          pwaState.value = false;
        }
        return pwaState;
      } catch (e) {
        console.error(e);
        return { value: false };
      }
    })(), // 是否安装pwa
    // openPwa: window?.pagePwaGame?.includes?.(+pwaAppId)||false, // 是否打开pwa
    // pwaActivityName: '', // pwa领奖活动标识
    visibleGotoAwardTipsPopup: getVisibleGotoAwardTipsPopup(), // 是否显示pwa跳转领奖弹窗
  },
  getters: {},
  mutations: {
    [UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP](state, visibleGotoAwardTipsPopup) {
      state.visibleGotoAwardTipsPopup = visibleGotoAwardTipsPopup;
    },
  },
  actions: {

  }
};
